module.exports = __webpack_public_path__ + "img/magicpen.33ec2804.svg";